import React from 'react';

import { useSeasonInfo } from '@/shared';
import Banner from '@/shared/assets/logos/banner.png';

import { ImageRow, StyledBanner } from './styled';

interface BannerSectionProps {
  onClick?: () => void;
  imagePath?: string;
}

export const BannerSection: React.FC<BannerSectionProps> = ({ onClick, imagePath }) => {
  const { data: seasonInfo } = useSeasonInfo();

  return (
    <ImageRow justify="center" onClick={onClick}>
      <StyledBanner
        src={imagePath ?? seasonInfo?.media?.home_page_banner_url ?? Banner}
        alt="CSPR.fans Banner"
      />
    </ImageRow>
  );
};
